function InsightArticleController(){
	this.className			= "InsightArticleController";
	this.view				= false; //"example";
	this.glob				= ["/press-commentary/market-insights**", "/press-commentary/market-insights?*"];
    this.log                = false;
}

InsightArticleController.inheritsFrom( PageController );

InsightArticleController.prototype.on = function(onComplete){
    return true;
}

InsightArticleController.prototype.setup = function(onComplete){
	if(this.isSetup) return;
	this.$body = $('body');
	this.$page  = this.$body.find('.js-page');
	this.isSetup = true;
}

InsightArticleController.prototype.swap = function(onComplete){
    if(!this.isSetup) this.setup();

	// commented out until needed (gives active link the dash prepend)
	
 //    this.$lhsNavigation = this.$page.find('.left-navigation');
 //    this.$lhsLinks		= this.$lhsNavigation.find('a');

 //    this.$lhsLinks.off('click').on("click", (e) => {
	// 	const $this = $(e.currentTarget);

	// 	this.$lhsLinks.removeClass('active');
	// 	$this.addClass('active');
	// });
}